module.exports = __webpack_public_path__ + "static/img/fiberLast-fiberglass-embedded06.2055df8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/fiberlast/fiberLast-fiberglass-embedded06.jpg
// module id = 775
// module chunks = 0